import React, { useEffect, useState } from 'react';
import supabase from '../supabase';

const statusOptions = ['Unread', 'Read', 'Contacted'];

const ContactSubmissionsAdmin = () => {
  const [submissions, setSubmissions] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchSubmissions = async () => {
    setLoading(true);
    const { data, error } = await supabase
      .from('contact_submissions')
      .select('*')
      .order('created_at', { ascending: false });
    setSubmissions(data || []);
    setLoading(false);
  };

  useEffect(() => {
    fetchSubmissions();
  }, []);

  const updateStatus = async (id, status) => {
    await supabase
      .from('contact_submissions')
      .update({ status })
      .eq('id', id);
    fetchSubmissions();
  };

  const deleteSubmission = async (id) => {
    await supabase
      .from('contact_submissions')
      .delete()
      .eq('id', id);
    fetchSubmissions();
  };

  if (loading) return <div>Loading submissions...</div>;

  return (
    <div style={{ padding: '2rem' }}>
      <h2>Contact Form Submissions</h2>
      {submissions.length === 0 ? (
        <div>No submissions yet.</div>
      ) : (
        <table style={{ width: '100%', background: '#18181b', color: 'white', borderRadius: 8 }}>
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Message</th>
              <th>Status</th>
              <th>Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {submissions.map(sub => (
              <tr key={sub.id}>
                <td>{sub.name}</td>
                <td>{sub.email}</td>
                <td>{sub.message}</td>
                <td>
                  <select value={sub.status} onChange={e => updateStatus(sub.id, e.target.value)}>
                    {statusOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                  </select>
                </td>
                <td>{new Date(sub.created_at).toLocaleString()}</td>
                <td>
                  <button onClick={() => deleteSubmission(sub.id)} style={{ color: 'red', background: 'none', border: 'none', cursor: 'pointer' }}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default ContactSubmissionsAdmin;
